export default "__VITE_ASSET__CyJs1gAS__"